import React, { useState } from 'react';
import { Form, Button, Popup, Header, Placeholder } from 'semantic-ui-react';
import { MailClient, MailStatusResponse } from '../api/Api';

function BasicPlaceholder({ ...rest }) {
    return (
        <Placeholder style={{ minWidth: '200px' }}>
            <Placeholder.Header>
                <Placeholder.Line />
                <Placeholder.Line />
            </Placeholder.Header>
            <Placeholder.Paragraph>
                <Placeholder.Line length='medium' />
                <Placeholder.Line length='short' />
            </Placeholder.Paragraph>
        </Placeholder>
    );
}

interface ResultView {
    header: string,
    subheader: string,
    note: string
}

export function MailStatus({ ...rest }) {
    const [email, setEmail] = useState<string>("");
    const [status, setStatus] = useState<MailStatusResponse | null>(null);
    const [resultView, setResultView] = useState<ResultView | null>(null);

    const mailClient = new MailClient();

    const tryme = async () => {
        const result = await mailClient.getMailStatus(email);

        const newResultView: ResultView =
        {
            header: window.wpMailManagerI18n.newResultViewHeader1,
            subheader: window.wpMailManagerI18n.newResultViewSubheader1,
            note: window.wpMailManagerI18n.newResultViewNote1
        }

        if (!result.mailExists) {
            newResultView.header = window.wpMailManagerI18n.newResultViewHeader2;
            newResultView.subheader = '';
            newResultView.note = '';
        }

        if (!result.mailWorking) {
            newResultView.header = window.wpMailManagerI18n.newResultViewHeader3;
            newResultView.subheader = '';
            newResultView.note = '';
        }

        if (result.mailExists == undefined && result.mailWorking == undefined) {
            newResultView.header = '';
            newResultView.subheader = window.wpMailManagerI18n.newResultViewSubheader4;
            newResultView.note = '';
        }

        setStatus(result);
        setResultView(newResultView);
        
        // Changing status in adminbar
        var adminBarFlashlight = document.querySelector('#wp-admin-bar-wp-mail-manager > div > span') as HTMLElement,
            mailExistsStatus = document.querySelector('#wp-admin-bar-wp-mail-manager-is-phpmail-exists > div > span') as HTMLElement,
            mailWorkingStatus = document.querySelector('#wp-admin-bar-wp-mail-manager-is-phpmail-working > div > span') as HTMLElement,
            smtpEnabledStatus = document.querySelector('#wp-admin-bar-wp-mail-manager-is-smtp-enabled > div > span') as HTMLElement;
            
        if (result.mailExists && result.mailWorking) {
            adminBarFlashlight.className = 'flashlight ok';
        } else {
            adminBarFlashlight.className = 'flashlight not-ok';
        }

        if (result.mailExists) {
            mailExistsStatus.className = 'ok';
            mailExistsStatus.innerHTML = window.wpMailManagerI18n.mailExists;
        } else {
            mailExistsStatus.className = 'not-ok';
            mailExistsStatus.innerHTML = window.wpMailManagerI18n.mailNotExists;
        }

        if (result.mailWorking) {
            mailWorkingStatus.className = 'ok';
            mailWorkingStatus.innerHTML = window.wpMailManagerI18n.mailWorking;
        } else {
            mailWorkingStatus.className = 'not-ok';
            mailWorkingStatus.innerHTML = window.wpMailManagerI18n.mailNotWorking;
        }

        if (result.smtpEnabled) {
            smtpEnabledStatus.className = 'ok';
            smtpEnabledStatus.innerHTML = window.wpMailManagerI18n.enabled;
        } else {
            smtpEnabledStatus.className = 'not-ok';
            smtpEnabledStatus.innerHTML = window.wpMailManagerI18n.disabled;
        }
    };

    return (
        <Form>
            <Form.Field>
                <label>{window.wpMailManagerI18n.mailStatusFormEmailLabel}</label>
                <input
                    placeholder='your-email@domain.com'
                    type='email'
                    value={email}
                    onChange={v => setEmail(v.target.value)}
                />
            </Form.Field>

            {<Popup
                on="click"
                onOpen={tryme}
                trigger={<Button type='submit'>{window.wpMailManagerI18n.mailStatusFormSubmitText}</Button>}
                position="bottom left"
            >
                {status === null ?
                    <BasicPlaceholder />
                    :
                    <>
                        <Header as='h2' content={resultView?.header} subheader={resultView?.subheader} />
                        <p>{resultView?.note}</p>
                    </>
                }
            </Popup>}

        </Form >
    );
}
